/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import { format } from 'date-fns';
import common from '../_common/common_sales';

const datasetParams = {
  mainFile: 'SalesAndAttendance/SalesAndAttendance_fullData.csv',
  runDetailsFile: 'SalesAndAttendance/SalesAndAttendance_fullData_runDetails.csv',
  tableName: 'Sales_and_Attendance',
  mainDateField: 'Date',
  headersRemaps: {
    NumberItemsSold: 'SalesUnits',
    NumberItemsSold_AllParks: 'SalesUnits_AllParks',
    Revenue: 'SalesRevenues',
    AdmissionRevenue: 'AdmissionRevenues',
    Weather_Code: 'WeatherCode',
  },
  calculatedMetrics: {
    SalesPerCap: {
      numerator: 'SalesRevenues',
      denominator: 'SalesUnits',
    },
    SalesPerCap_AllParks: {
      numerator: 'SalesRevenues',
      denominator: 'SalesUnits_AllParks',
    },
    AdmissionPerCap: {
      numerator: 'AdmissionRevenues',
      denominator: 'Attendance',
    },
    WeatherCode_weighed: {
      numerator: 'WeightedWeatherCodes',
      denominator: 'Weather_Code_Weight',
    },
  },
  metrics: {
    SalesUnits: {
      fieldName: 'SalesUnits',
      displayName: 'Sales Units',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    SalesUnits_AllParks: {
      fieldName: 'SalesUnits_AllParks',
      displayName: 'Sales Units All Parks',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    SalesPerCap: {
      fieldName: 'SalesPerCap',
      displayName: 'Sales Per Cap',
      chartFormat: '$.2f',
      format: {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      },
    },
    SalesPerCap_AllParks: {
      fieldName: 'SalesPerCap_AllParks',
      displayName: 'Sales Per Cap All Parks',
      chartFormat: '$.2f',
      format: {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      },
    },
    SalesRevenues: {
      fieldName: 'SalesRevenues',
      displayName: 'Sales Revenues',
      chartFormat: '$~s',
      format: {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        // maximumSignificantDigits: 3,
      },
    },
    Attendance: {
      fieldName: 'Attendance',
      displayName: 'Attendance',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    AdmissionPerCap: {
      fieldName: 'AdmissionPerCap',
      displayName: 'Admission Per Cap',
      chartFormat: '$.2f',
      format: {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
        // minimumFractionDigits: 2,
      },
    },
    AdmissionRevenues: {
      fieldName: 'AdmissionRevenues',
      displayName: 'Admisssion Revenues',
      chartFormat: '$~s',
      format: {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        // maximumSignificantDigits: 3,
      },
    },
    WeatherCode_weighed: {
      fieldName: 'WeatherCode_weighed',
      displayName: 'Weather Code',
      chartFormat: '.2f',
      format: {
        style: 'decimal',
        maximumFractionDigits: 2,
      },
    },
  },
  valuesRemaps: {
    Channel: {
      'Internet - Consumer Direct': 'Internet',
    },
    ProductType: {
      'MDT/MPT': 'MDT',
    },
    Flag_HOS: {
      0: '0',
    },
  },
  transformRow: (row) => ({
    ...row,
    Date: format(new Date(row.Date), 'yyyy-MM-dd'),
    Year: format(new Date(row.Date), 'yyyy'),
    YearMonth: format(new Date(row.Date), 'yyyy-MM'),
    ProductCategory: ['SDT', 'MDT'].includes(row.ProductType) ? 'Discrete' : ['FC', 'Fun Card', 'Pass'].includes(row.ProductType) ? 'Pass' : 'Free',
  }),
  filterDimensions: {
    Park: {
      order: 'asc',
      customOrder: ['SWF', 'APO', 'BGT', 'AIT', 'SWC', 'SPC', 'SWT', 'APT', 'BGW', 'WCW', 'SPL'],
    },
    Date: {
      // order: 'desc',
      sortType: 'alpha',
    },
    Year: {
      // order: 'desc',// Gets overridden by the getFilterValues special case
      sortType: 'alpha',
    },
    YearMonth: {
      // order: 'desc',// Gets overridden by the getFilterValues special case
      sortType: 'alpha',
    },
    Channel: {
      order: 'desc',
      customOrder: ['Internet', 'In-Park', 'Contact Center', 'Business Partner'],
    },
    ProductCategory: {
      order: 'desc',
      customOrder: ['Discrete', 'Pass', 'Free'],
    },
    ProductType: {
      order: 'desc',
      customOrder: ['SDT', 'MDT', 'FC', 'Fun Card', 'Pass', 'Free'],
    },
    Flag_HOS: {
      order: 'asc',
    },
  },
};

export default datasetParams;
